import {FingerFlashCardPage} from "./finger-flash-card/finger-flash-card";
import {FingerBasicPage} from "./finger-basic/finger-basic";
import {FingerLittleFriendPlusPage} from "./finger-little-friend-plus/finger-little-friend-plus";
import {FingerLittleFriendMinusPage} from "./finger-little-friend-minus/finger-little-friend-minus";
import {FingerBigFriendPlusPage} from "./finger-big-friend-plus/finger-big-friend-plus";
import {FingerBigFriendMinusPage} from "./finger-big-friend-minus/finger-big-friend-minus";
import {FingerPlusMinusPage} from "./finger-plus-minus/finger-plus-minus";
import {SorobanBasicFlashCardPage} from "./soroban-basic-flash-card/soroban-basic-flash-card";
import {SorobanBasicBasicPage} from "./soroban-basic-basic/soroban-basic-basic";
import {SorobanBasicLittleFriendPlusPage} from "./soroban-basic-little-friend-plus/soroban-basic-little-friend-plus";
import {SorobanBasicLittleFriendMinusPage} from "./soroban-basic-little-friend-minus/soroban-basic-little-friend-minus";
import {SorobanBasicBigFriendPlusPage} from "./soroban-basic-big-friend-plus/soroban-basic-big-friend-plus";
import {SorobanBasicBigFriendMinusPage} from "./soroban-basic-big-friend-minus/soroban-basic-big-friend-minus";
import {SorobanAddSubAddSubPage} from "./soroban-add-sub-add-sub/soroban-add-sub-add-sub";
import {SorobanAddSubAddSubSoThapPhanPage} from "./soroban-add-sub-add-sub-so-thap-phan/soroban-add-sub-add-sub-so-thap-phan";
import {SorobanAddSubAddSubSoAmPage} from "./soroban-add-sub-add-sub-so-am/soroban-add-sub-add-sub-so-am";
import {SorobanMultiOnePage} from "./soroban-multi-one/soroban-multi-one";
import {SorobanMultiTwoPage} from "./soroban-multi-two/soroban-multi-two";
import {SorobanDivisonOnePage} from "./soroban-divison-one/soroban-divison-one";
import {SorobanDivisonTwoPage} from "./soroban-divison-two/soroban-divison-two";

const CONFIG_PAGES = {
    FingerFlashCardPage: FingerFlashCardPage,
    FingerBasicPage: FingerBasicPage,
    FingerLittleFriendPlusPage: FingerLittleFriendPlusPage,
    FingerLittleFriendMinusPage: FingerLittleFriendMinusPage,
    FingerBigFriendPlusPage: FingerBigFriendPlusPage,
    FingerBigFriendMinusPage: FingerBigFriendMinusPage,
    FingerPlusMinusPage: FingerPlusMinusPage,
    SorobanBasicFlashCardPage: SorobanBasicFlashCardPage,
    SorobanBasicBasicPage: SorobanBasicBasicPage,
    SorobanBasicLittleFriendPlusPage: SorobanBasicLittleFriendPlusPage,
    SorobanBasicLittleFriendMinusPage: SorobanBasicLittleFriendMinusPage,
    SorobanBasicBigFriendPlusPage: SorobanBasicBigFriendPlusPage,
    SorobanBasicBigFriendMinusPage: SorobanBasicBigFriendMinusPage,
    SorobanAddSubAddSubPage: SorobanAddSubAddSubPage,
    SorobanAddSubAddSubSoThapPhanPage: SorobanAddSubAddSubSoThapPhanPage,
    SorobanAddSubAddSubSoAmPage: SorobanAddSubAddSubSoAmPage,
    SorobanMultiOnePage: SorobanMultiOnePage,
    SorobanMultiTwoPage: SorobanMultiTwoPage,
    SorobanDivisonOnePage: SorobanDivisonOnePage,
    SorobanDivisonTwoPage: SorobanDivisonTwoPage
};

export default CONFIG_PAGES;


// WEBPACK FOOTER //
// ./src/pages/CONFIG_PAGES.ts